import { action as toggleMenu } from 'redux-burger-menu'
import { useDispatch, useSelector } from 'react-redux'
import { menuStatus } from '../../redux/selectors'
import { memo, useCallback } from 'react'
import cn from 'classnames'
import Logo from '../logo/logo'
import NavLinks from './nav-links'
import ButtonsContainer from './buttons-container'
import { ReactComponent as MenuIcon } from '../../assets/svg/menu.svg'


const Wrapper = ({ isHomePage, navigate }) => {
   const dispatch = useDispatch()
   const status = useSelector(menuStatus)
   const onClickHandler = useCallback(()=> {!isHomePage && navigate('/')}, [isHomePage])

   if (status !== 'success') return null

   return (
      <header className={cn('header', { header_reversed: isHomePage })}>
         <div className='container'>
            <div className='header__row-top'>
               <p>Пн-Вс 10-19</p>
               <a href='tel:84952298559'>8 (495) 229 85 59</a>
            </div>

            <div className='header__row-bottom'>
               <button
                  className='header__btn-burger'
                  onClick={() => dispatch(toggleMenu(true, 'main'))}
                  aria-label='главное меню'
               >
                  <MenuIcon />
               </button>

               <div className='header__logo-container'>
                  <Logo reversed={!!isHomePage} onClickHandler={onClickHandler} aria-label='домашняя страница' />
               </div>

               <ButtonsContainer navigate={navigate} />
               <NavLinks />
            </div>
         </div>
      </header>
   )
}

export default memo(Wrapper)
